import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger', 'content'];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasTriggerTarget) return;

    this.contentTargets.forEach((content) => {
      content.classList.toggle('hidden', !this.triggerTarget.checked);
    });
  }
}
